export const airplay = {
  name: "airplay" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="currentColor"><path fill-rule="evenodd" d="M1.6 5.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 .9.9v14a.9.9 0 0 1-.9.9H18a.9.9 0 1 1 0-1.8h2.6V6.4H3.4v12.2H6a.9.9 0 1 1 0 1.8H2.5a.9.9 0 0 1-.9-.9v-14ZM12 14.6a.9.9 0 0 1 .76.417l3.5 5.5a.9.9 0 0 1-.76 1.383h-7a.9.9 0 0 1-.76-1.383l3.5-5.5A.9.9 0 0 1 12 14.6Zm-1.86 5.5h3.72L12 17.176 10.14 20.1Z" clip-rule="evenodd"/></svg>`,
  keywords: ["airplay"],
  category: "media" as const,
};
